import { Component } from "@angular/core";
import { MdDialog, MdDialogRef, MdSnackBar } from "@angular/material";
import { AddNewAdvertisementDialogComponent } from "./add-new-advertisement/add-new-advertisement.component";
import Swal from "sweetalert2";
import { LicenseService } from "../services/LicenseService";
import { AppLoaderService } from "../../services/app-loader/app-loader.service";

@Component({
    selector:'advertisement',
    template:require('./advertisement.component.html'),
    styles:[require('./advertisement.component.css')],
})
export class AdvertisementComponent{
    advertisementList=[];
    
    errorMessage='';
    constructor(
        public dialog:MdDialog,
        private licenseService:LicenseService,
        private snackBar:MdSnackBar,
        private appLoader:AppLoaderService){
            this.getAllAdvertisement();
    }
    addNewAdvertisement(){
        let addNewAdvertisementDialog:MdDialogRef<AddNewAdvertisementDialogComponent>=
        this.dialog.open(AddNewAdvertisementDialogComponent,{
            data:{
                SelectedAdvData:null,
                Advlist:this.advertisementList
            },
            disableClose:true,
            height:'70%',
            width:'50%'
        });
        addNewAdvertisementDialog.afterClosed().subscribe((result)=>{
            this.advertisementList=result
        })

    }
    getAllAdvertisement(){
        this.appLoader.open();
        this.licenseService.getAllAdvertisement().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.advertisementList=data.DataObject;
                this.appLoader.close();
            }
            else{
                this.appLoader.close();
            }
        })
    }
    editAdvertisement(advData){
        let editAdvertisementDialogRef:MdDialogRef<AddNewAdvertisementDialogComponent>=
            this.dialog.open(AddNewAdvertisementDialogComponent,{
                data:{
                    SelectedAdvData:advData,
                    Advlist:this.advertisementList
                },
                height:'70%',
                width:'50%',
                disableClose:true
            });
            editAdvertisementDialogRef.afterClosed().subscribe((result)=>{
                this.advertisementList=result
            })    
    }
    deleteAdvertisement(row){
       Swal.fire({
                   title:'Delete Advertisement',
                   text:'Are you sure you want to delete advertisement?',
                   showCancelButton:true,
                   showCloseButton:true,
                   showConfirmButton:true,
                   confirmButtonColor:'#FFCA28',
                   confirmButtonText:'Yes',
                   cancelButtonText:'No'
               }).then((result)=>{
                   if(result.isConfirmed){
                    let model={
                        LZ30AdvertisementId:row.LZ30AdvertisementId,
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    this.appLoader.open()
                    this.licenseService.deleteAdvertisement(model).subscribe((response)=>{
                        if(!response.IsError && response.DataObject!=null){
                            this.advertisementList=response.DataObject;
                            this.appLoader.close();
                            this.snackBar.open("Advertisement deleted successfully.","",{
                                duration:2000
                            })
                        }
                        else{
                            this.appLoader.close();
                            Swal.fire({
                                title:"Error",
                                text:response.Error
                            })
                        }
                    });
                   }
               })
    }
    activeAdvertisement(row){
        Swal.fire({
            title:'Active Advertisement',
            text:'Are you sure you want to active the advertisement?',
            showCancelButton:true,
            showCloseButton:true,
            showConfirmButton:true,
            confirmButtonColor:'#FFCA28',
            confirmButtonText:'Yes',
            cancelButtonText:'No'
        }).then((result)=>{
            if(result.isConfirmed){
                let model={
                    LZ30AdvertisementId:row.LZ30AdvertisementId,
                    IsActive:true,
                    UpdatedBy:Number(localStorage.getItem('userid')),
                }
                this.appLoader.open()
                this.licenseService.updateActiveInactiveAdvertisement(model).subscribe((response)=>{
                    if(!response.IsError && response.DataObject!=null){
                        this.advertisementList=response.DataObject;
                        this.appLoader.close();
                        this.snackBar.open("Advertisement activated successfully.","",{
                            duration:2000
                        })
                    }
                    else{
                        this.appLoader.close();
                        Swal.fire({
                            title:"Error",
                            text:response.Error,
                            showConfirmButton:true,
                            confirmButtonColor:' #FFCA28',
                            returnFocus:true
                        })
                        
                    }
                })
            }
        })
    }

    deactiveAdvertisement(row){
        Swal.fire({
            title:'Deactive Advertisement',
            text:'Are you sure you want to deactive the advertisement?',
            showCancelButton:true,
            showCloseButton:true,
            showConfirmButton:true,
            confirmButtonColor:'#FFCA28',
            confirmButtonText:'Yes',
            cancelButtonText:'No'
        }).then((result)=>{
            if(result.isConfirmed){
                let model={
                    LZ30AdvertisementId:row.LZ30AdvertisementId,
                    IsActive:false,
                    UpdatedBy:Number(localStorage.getItem('userid')),
                }
                this.appLoader.open()
                this.licenseService.updateActiveInactiveAdvertisement(model).subscribe((response)=>{
                    if(!response.IsError && response.DataObject!=null){
                        this.advertisementList=response.DataObject;
                        this.appLoader.close();
                        this.snackBar.open("Advertisement deactivated successfully.","",{
                            duration:2000
                        })

                    }
                    else{
                        this.appLoader.close();
                        Swal.fire({
                            title:"Error",
                            text:response.Error
                        })
                    }
                })
            }
        })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/advertisement/advertisement.component.ts